export default "__VITE_ASSET__H$J9eZBZ__"